import Config from "@/const/Config";
import { KoyouKeiyakuTimeAndHayabanOsobanOptions, KoyouKeiyakuTimeAndHayabanOsobanReq, KoyouKeiyakuTimeOptions, KoyouKeiyakuTimeReq } from "@/types/KoyouKeiyakuTime";
import { BaseApi } from "@/api/BaseApi";
import { KoyouKeiyakuTime } from "@/types/KoyouKeiyaku";

export class KoyouKeiyakuTimeApi extends BaseApi {
  /**
   * 雇用契約就業時間一覧を取得します
   * @returns 該当雇用契約の雇用契約就業時間一覧
   */
  public async getByKoyouKeiyakuId(req: KoyouKeiyakuTimeReq): Promise<KoyouKeiyakuTime[]> {
    try {
      const res = await this.post<KoyouKeiyakuTime[]>(Config.API_URL + '/koyou_keiyaku_time/all', null);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 雇用契約就業時間一覧を取得します（オプション値）
   * @returns 該当雇用契約の雇用契約就業時間一覧
   */
   public async getOptionsByKoyouKeiyakuId(req: KoyouKeiyakuTimeReq): Promise<KoyouKeiyakuTimeOptions[]> {
    try {
      const res = await this.post<KoyouKeiyakuTimeOptions[]>(Config.API_URL + '/koyou_keiyaku_time/options/all', null);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 指定日の雇用契約就業時間を取得します
   * @returns 当該曜日の雇用契約就業時間一覧
   */
   public async getByKoyouKeiyakuIdAndDate(req: KoyouKeiyakuTimeReq): Promise<KoyouKeiyakuTime[]> {
    try {
      const res = await this.post<KoyouKeiyakuTime[]>(Config.API_URL + '/koyou_keiyaku_time/date', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 指定日の雇用契約就業時間を取得します（オプション値）
   * @returns 当該曜日の雇用契約就業時間一覧
   */
   public async getOptionsByKoyouKeiyakuIdAndDate(req: KoyouKeiyakuTimeReq): Promise<KoyouKeiyakuTimeOptions[]> {
    try {
      const res = await this.post<KoyouKeiyakuTimeOptions[]>(Config.API_URL + '/koyou_keiyaku_time/options/date', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 指定日の雇用契約就業時間を取得します（オプション値）
   * @returns 当該曜日の雇用契約就業時間一覧
   */
  public async getOptionsOrHayabanOsobanByKoyouKeiyakuIdAndDate(req: KoyouKeiyakuTimeReq): Promise<KoyouKeiyakuTimeOptions[]> {
    try {
      const res = await this.post<KoyouKeiyakuTimeOptions[]>(Config.API_URL + '/koyou_keiyaku_time/options/or_hayaban_osoban', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 指定日の雇用契約就業時間を取得します（オプション値）
   * @returns 当該曜日の雇用契約就業時間一覧
   */
  public async getOptionsAndHayabanOsobanByKoyouKeiyakuId(req: KoyouKeiyakuTimeAndHayabanOsobanReq): Promise<KoyouKeiyakuTimeAndHayabanOsobanOptions> {
    try {
      const res = await this.post<KoyouKeiyakuTimeAndHayabanOsobanOptions>(Config.API_URL + '/koyou_keiyaku_time/options/and_hayaban_osoban', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }
}
